import { RichText } from '../i18n/RichText';
import { t } from '../services/language-manager';

interface ErrorPageProps {
  title: string;
  message: string;
  details?: string;
  missingPermissions?: string[];
  isServiceUnavailable?: boolean;
}

export function ErrorPage({ title, message, details, missingPermissions, isServiceUnavailable }: ErrorPageProps) {
  return (
    <div className="card error-page">
      <div className="error-page__icon">{'\u26A0'}</div>
      <div className="error-page__title">{title}</div>
      <div className="error-page__message">{message}</div>

      {isServiceUnavailable && (
        <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginTop: '12px' }}>
          <RichText
            k="error-service-unavailable-retry"
            values={{
              email: <a href="mailto:service@mediabriz.com" dir="ltr" style={{ color: 'var(--brand-blue)', textDecoration: 'none' }}>service@mediabriz.com</a>,
            }}
          />
        </p>
      )}

      {missingPermissions && missingPermissions.length > 0 && (
        <ul className="error-page__permissions" dir="ltr">
          {missingPermissions.map((perm) => (
            <li key={perm}>{perm}</li>
          ))}
        </ul>
      )}

      {details && (
        <div className="error-page__details">
          <strong>{t('error-backend-details')}:</strong>
          <br />
          {details}
        </div>
      )}

      {!isServiceUnavailable && (
        missingPermissions && missingPermissions.length > 0 ? (
          <p style={{ fontSize: '13px', color: 'var(--text-muted)' }}>
            <RichText
              k="error-missing-permissions-help"
              values={{
                support: (
                  <a href="https://support.mediabriz.com" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--brand-blue)', textDecoration: 'none' }}>
                    {t('error-missing-permissions-support-link')}
                  </a>
                ),
                email: (
                  <a href="mailto:service@mediabriz.com" dir="ltr" style={{ color: 'var(--brand-blue)', textDecoration: 'none' }}>
                    service@mediabriz.com
                  </a>
                ),
              }}
            />
          </p>
        ) : (
          <p style={{ fontSize: '13px', color: 'var(--text-muted)' }}>
            <RichText
              k="error-backend-resolve"
              values={{
                email: <a href="mailto:service@mediabriz.com" dir="ltr" style={{ color: 'var(--brand-blue)', textDecoration: 'none' }}>service@mediabriz.com</a>,
              }}
            />
          </p>
        )
      )}
    </div>
  );
}
